//Imagen
import banner1440 from '../../../Activos/Imagenes/BannerHome/banner1440.svg';

export const ComponenteExtra1440Style = {
    DivStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        paddingLeft: 158,
        paddingRight: 158,
        backgroundImage: 'url(' + banner1440 + ')',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        alignItems: 'center',
        gap: 20,
        height: 165,
        width: 'auto'
    },
    ImgStyle: {
        width: '349px',
        height: '59px',
    },
    DivTextStyle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginLeft: 'auto',
        textAlign: 'right',
        gap: 10
    },
    DescriptionTextStyle: {
        maxWidth: 345,
        color: '#FFFFFF',
        fontSize: '24px',
        fontWeight: 700,
        lineHeight: '32px',
        letterSpacing: 0
    }
};